<ng-template #preHeader>
    <shared-disabled-text>SIGN IN /</shared-disabled-text> SIGN UP
</ng-template>
<shared-auth-header [preHeader]="preHeader" [description]="description">
    Register your card
</shared-auth-header>
<ng-template #description>
    Enter the number on your printed card. Don’t have a card? Just skip this step below and we will make you a shiny new
    digital one.
</ng-template>
<shared-form-for-member-card [modal]="true"></shared-form-for-member-card>